export default "__VITE_ASSET__kTBNHpoQ__"